import { render, staticRenderFns } from "./personalCenterMainView.vue?vue&type=template&id=71a56b7a&scoped=true&"
import script from "./personalCenterMainView.vue?vue&type=script&lang=js&"
export * from "./personalCenterMainView.vue?vue&type=script&lang=js&"
import style0 from "./personalCenterMainView.vue?vue&type=style&index=0&id=71a56b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a56b7a",
  null
  
)

export default component.exports